import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d77ac8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "d-flex justify-content-between flex-column flex-sm-row gap-3 gap-sm-0 align-items-center py-4 px-3" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logo,
        alt: "logo"
      }, null, 8, _hoisted_3),
      (!_ctx.isSlideShow)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            onClick: _ctx.toggleSlideShow,
            to: "/galleria/paint1",
            class: "link-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode("start slideshow ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            onClick: _ctx.toggleSlideShow,
            to: "/galleria",
            class: "link-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode("stop slideshow ")
            ]),
            _: 1
          }, 8, ["onClick"]))
    ]),
    _hoisted_4
  ]))
}